// useCanvasLayout — the swim-lane layout for the loaded topology and the
// current active paths. Shared by the canvas and the zoom panel (which sits
// outside the canvas, in the HUD) so both measure the same content.

import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { selectLanes, selectBranchLanes, selectFrames } from '../../store/slices/topologySlice.ts';
import { selectActivePaths } from '../../store/slices/uiSlice.ts';
import { selectActivatedBranches } from '../../store/slices/simulationSlice.ts';
import { computeLayout } from './layoutEngine.ts';

export function useCanvasLayout() {
  const lanes = useSelector(selectLanes);
  const branchLanes = useSelector(selectBranchLanes);
  const frames = useSelector(selectFrames);
  const activePaths = useSelector(selectActivePaths);
  const activatedBranches = useSelector(selectActivatedBranches);

  const allLanes = useMemo(() => [...lanes, ...branchLanes], [lanes, branchLanes]);
  const activePathSet = useMemo(
    () => new Set([...activePaths, ...activatedBranches]),
    [activePaths, activatedBranches],
  );
  return useMemo(
    () => computeLayout(allLanes, frames, activePathSet),
    [allLanes, frames, activePathSet],
  );
}
